import { combineReducers } from 'redux';

import accountExecutive from './accountExecutive.reducer';
import actionItems from './actionItems.reducer';
import activityFeed from './activityFeed.reducer';
import announcements from './announcements.reducer';
import approvalScope from './approvalScope.reducer';
import clientProtection from './clientProtection.reducer';
import closingThisWeek from './closingThisWeek.reducer';
import commandCenterMonthlyVolume from './commandCenterMonthlyVolume.reducer';
import commandCenterSummary from './commandCenterSummary.reducer';
import companyVolume from './companyVolume.reducer';
import compPlan from './compPlan.reducer';
import conditionHeatmap from './conditionHeatmap.reducer';
import disclosureTiming from './disclosureTiming.reducer';
import earnings from './earnings.reducer';
import epoWatch from './epoWatch.reducer';
import fileQualityScorecard from './fileQualityScorecard.reducer';
import licenseSummary from './licenseSummary.reducer';
import loadStatus from './loadStatus.reducer';
import lockExposure from './lockExposure.reducer';
import marketRates from './marketRates.reducer';
import ownerStatus from './ownerStatus.reducer';
import pipelineFunnel from './pipelineFunnel.reducer';
import pipelineStatus from './pipelineStatus.reducer';
import queueDepth from './queueDepth.reducer';
import rateSheetMovement from './rateSheetMovement.reducer';
import shopPipeline from './shopPipeline.reducer';
import turnTimeStages from './turnTimeStages.reducer';
import turnTimeTrend from './turnTimeTrend.reducer';

const reducer = {
  commandCenter: combineReducers({
    accountExecutive,
    actionItems,
    activityFeed,
    announcements,
    approvalScope,
    clientProtection,
    commandCenterMonthlyVolume,
    commandCenterSummary,
    companyVolume,
    closingThisWeek,
    compPlan,
    conditionHeatmap,
    disclosureTiming,
    earnings,
    epoWatch,
    fileQualityScorecard,
    licenseSummary,
    loadStatus,
    lockExposure,
    marketRates,
    ownerStatus,
    pipelineFunnel,
    pipelineStatus,
    queueDepth,
    rateSheetMovement,
    shopPipeline,
    turnTimeStages,
    turnTimeTrend,
  }),
};

export default reducer;
